<template>
  <section class="about" id="_">
    <headeR />
  </section>
</template>
  
<script>
  import headeR from "@/components/aboutHeader.vue";
  
  export default {
    name: "About",
    components: {
      headeR,
    }
  };
</script>
  
<style scoped lang="scss">
  .about {
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1366px;
    margin: 0 auto -55px auto;
    padding-bottom: calc(2em + 55px);
    background: #fff;
    transition: .4s;
  }
  
  @media (prefers-color-scheme: dark) {
    .about {
      background: #000;
    }
  }

  @media (prefers-color-scheme: light) {
    .about {
      background: #fff;
    }
  }

  @media screen and (max-width: 900px) {
    .about {
      margin: 0 auto 0 auto;
    }
  }
   
  @media screen and (max-width: 780px) {
    .about {
      height: auto;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  
  @media screen and (max-width: 480px) {
    .about {
      height: auto;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

</style>
  